import type { IFluoroAnglesCalculator, IFluoroAnglesIntegrationApi } from './interfaces';
import { injectable } from 'inversify';
import { DisposablesBasket } from '@/engine/Utilities/DisposablesBasket';
import * as THREE from 'three';
import type { CallbackSubscription } from '@/engine/Utilities/CallbackManager';
import { CallbackManager } from '@/engine/Utilities/CallbackManager';
import { fluoroAnglesFromCamera } from '@/engine/utils/geometryHelper';

@injectable()
export class FluoroAnglesCalculator implements IFluoroAnglesCalculator {
  private readonly _subscriptions = new DisposablesBasket();

  private readonly _listeners: CallbackManager<(raoLao: number, caudCran: number) => void>;

  public constructor(api: IFluoroAnglesIntegrationApi) {
    this._subscriptions.add(api.trackCameraOrientationChanges((quaternion) => this._onOrientationChanged(quaternion)));
    this._listeners = new CallbackManager();
  }

  public trackAngles(callback: (raoLao: number, caudCran: number) => void): CallbackSubscription {
    return this._listeners.subscribe(callback);
  }

  private _onOrientationChanged(quaternion: THREE.Quaternion): void {
    const toCameraDir = new THREE.Vector3(0, 0, 1).applyQuaternion(quaternion);
    const res = fluoroAnglesFromCamera(toCameraDir);
    this._listeners.invoke(res.raoLao, res.caudCran);
  }

  public dispose(): void {
    this._subscriptions.dispose();
  }
}
